import { normalize, setupPage } from 'csstips';
import { injectGlobal } from '../theme/global';

export const setupGlobalCSS = (root = '#root') => {
  normalize();
  setupPage(root);
  injectGlobal();
};
